// import {produce} from 'immer';

export const selectVehicleStorageVisualizerStack = (set, get, stackId) => {
  const state = get();
  if (!state || !state.design) return;

  set({
    design: {
      ...state.design,
      selectedVisualizerStackId: stackId,
      selectedProduct: null,
    },
  }, false, { type: 'SELECT_VISUALIZER_STACK', payload: { stackId } });
};
